module.exports = __webpack_public_path__ + "static/media/SherlockBones.5a0c75ae.jpg";